export default class SupplierAlertConfig {
  constructor() {
    this.companyId = '';
    this.numDays = 1;
    this.onlyWorkDays = false;
    this.delayedDays = 0;
  }

  init(supplierAlertConfig) {
    this.companyId = supplierAlertConfig?.id ?? '';
    this.numDays = supplierAlertConfig?.numDays ?? 1;
    this.onlyWorkDays = supplierAlertConfig?.onlyWorkDays ?? false;
    this.delayedDays = supplierAlertConfig?.delayedDays ?? 0;
  }
}
